import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function NarrativeHook() {
  return <section className="w-full mb-12" data-id="element-62">
      <div className="bg-tech-grey-10 border-l-4 border-passion-red rounded-r-xl p-6 md:p-8 shadow-sm relative overflow-hidden" data-id="element-63">
        <div className="absolute top-0 right-0 opacity-5 pointer-events-none transform translate-x-1/4 -translate-y-1/4" data-id="element-64">
          <BookOpenIcon className="w-64 h-64 text-tech-grey" data-id="element-65" />
        </div>

        <div className="relative z-10" data-id="element-66">
          <div className="flex items-center gap-3 mb-4" data-id="element-67">
            <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-68">
              <BookOpenIcon className="w-5 h-5" data-id="element-69" />
            </div>
            <h2 className="font-heading text-xl font-bold text-tech-grey uppercase tracking-wider" data-id="element-70">
              Ihre Wettbewerbslandschaft
            </h2>
          </div>

          <blockquote className="font-body text-xl md:text-2xl text-tech-grey-75 italic leading-relaxed max-w-5xl" data-id="element-71">
            "Polytec zeigt mit dem Schwenk auf wiederverwendbare
            Militärlogistikboxen aus glasfaserverstärktem Polyamid und einem
            starken EBIT-Turnaround klare Stärke. Doch das Umfeld bewegt sich:
            ElringKlinger setzt alles auf Batterien und schließt Werke, Röchling
            bleibt leise profitabel, und Woco kämpft mit hoher Verschuldung. Wie
            positioniert sich Polytec in dieser fragmentierenden
            Zulieferlandschaft?"
          </blockquote>
        </div>
      </div>
    </section>;
}